import React from 'react'

import Grid, { Col } from '../../../../../components/pdf/Grid'
import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'

const Header = () => (
  <>
    <Grid justify="space-between" align="center">
      <Col>
        <Image src="/pdfs/template-sso/unimed-logo.png" maxWidth={100} ignoreFixedSize />
      </Col>

      <Col>
        <Text italic bold size="xsmall">
          Programa de Gerenciamento de Riscos - PGR
        </Text>
      </Col>
    </Grid>
    <Separator weight={6} />
  </>
)

export default Header
